// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".components-pages-index-page-index-articles-content-collections-eeokg{display:grid;grid-gap:24px}.components-pages-index-page-index-articles-content-collections-eeokg.components-pages-index-page-index-articles-content-desktop-bbapf{grid-template-columns:repeat(4,1fr)}.components-pages-index-page-index-articles-content-collections-eeokg.components-pages-index-page-index-articles-content-mobile-cbidb{grid-template-columns:repeat(2,1fr)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"collections": "components-pages-index-page-index-articles-content-collections-eeokg",
	"desktop": "components-pages-index-page-index-articles-content-desktop-bbapf",
	"mobile": "components-pages-index-page-index-articles-content-mobile-cbidb"
};
module.exports = ___CSS_LOADER_EXPORT___;
